import React, { useState, useEffect } from 'react';
import Button from '../Buttons/ButtonBase';
import './index.scss';
import MembershipModal from "../Modal/MembershipModal";
import { connect } from 'react-redux';
import { openModalPayments } from "../../store/actions/ModalsActions";


const bandera = '/img/icons/bandera-mint.svg';

function MembershipCards(props) {
  const { platinum, openModalPayments } = props;
  let monthly = "monthly"; //monthly singlePayments
  let membershipPeriod = "sixMonths" //sixMonths annual

  const handleOpenModal = (membership) => {
    openModalPayments(true, membership, monthly, membershipPeriod);
  }

  return (
    <>
      <MembershipModal />
      <div className="inversion-card-container">
        <div className="inversion-card">
          <div className="inversion-card-basic">
            <div className="inversion-card-flex-section">
              <div>
                <div className="inversion-card-top">
                  <div className="inversion-card-top-bar"></div>
                  <div className="inversion-card-top-title">
                    <p>Free</p>
                  </div>
                  <div className="inversion-card-top-subtitle">
                    <p>Plan básico e informativo</p>
                  </div>
                </div>

                <div className="inversion-card-content">
                  <div className="inversion-card-content-price">
                    <p>GRATIS</p>
                  </div>
                  <div className="inversion-card-content-desc">
                    <ul>
                      <li>
                        Perfil <span>profesional</span>.
                      </li>
                      <li>
                        Interacción con <span>clientes potenciales</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="inversion-card-bottom">
                <Button variant="primary" disabled>
                  Adquirir
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="inversion-card">
          <div className="inversion-card-standar">
            <div className="inversion-card-flex-section">
              <div>
                <div className="inversion-card-top">
                  <div className="inversion-card-top-bar"></div>
                  <div className="inversion-card-top-title">
                    <p>Standar</p>
                  </div>
                  <div className="inversion-card-top-subtitle">
                    <p>Plan perfecto para 1 usuario</p>
                  </div>
                </div>

                <div className="inversion-card-content">
                  <div className="inversion-card-content-price">
                    <p>GRATIS</p>
                    <div className="inversion-card-content-price-details">
                      <span className="val-price"></span>
                      <span className="text-price">Por tiempo limitado</span>
                    </div>
                  </div>
                  <div className="inversion-card-content-desc">
                    <ul>
                      <li>
                        Perfil <span>profesional</span>
                      </li>
                      <li>
                        Interacción con <span>clientes potenciales</span>
                      </li>
                      <li>Integración con WhatsApp</li>
                      <li>Dashboard con análisis de resultados</li>
                      <li>
                        Compartir perfil profesional en sus redes sociales
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="inversion-card-bottom">
                <Button onClick={() => handleOpenModal('premium')} variant="primary">Adquirir</Button>
              </div>
            </div>
          </div>
        </div>

        <div className="inversion-card">
          <div className="inversion-card-platinum">
            <img className="marker" src={bandera} alt="membresia platinum" />
            <div className="inversion-card-flex-section">
              <div>
                <div className="inversion-card-top">
                  <div className="inversion-card-top-bar"></div>
                  <div className="inversion-card-top-title">
                    <p>Platinum</p>
                  </div>
                  <div className="inversion-card-top-subtitle">
                    <p>Plan perfecto para despachos</p>
                  </div>
                </div>

                <div className="inversion-card-content">
                  <div className="inversion-card-content-price">
                    <p>{platinum.price}</p>
                    <div className="inversion-card-content-price-details">
                      <span className="val-price">{platinum.priceDisc}</span>
                      <span className="text-price">{platinum.detail}</span>
                    </div>
                  </div>
                  <div className="inversion-card-content-desc">
                    <ul>
                      <li>
                        Perfil <span>profesional</span>
                      </li>
                      <li>
                        Interacción con <span>clientes potenciales</span>
                      </li>
                      <li>Integración con WhatsApp</li>
                      <li>Dashboard con análisis de resultados</li>
                      <li>
                        Compartir perfil profesional en sus redes sociales
                      </li>
                      <li>Agregar abogados a tu equipo de trabajo</li>
                      <li>Primeros lugares de posicionamiento en búsquedas</li>
                    </ul>
                    <p>Sé parte del top de despachos</p>
                  </div>
                </div>
              </div>
              <div className="inversion-card-bottom">
                <Button onClick={() => handleOpenModal('premium_plus')} variant="primary">Contratar</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapDispatchToProps = dispatch => ({
  openModalPayments: (open, typeMembership, typePayment, membershipPeriod) => dispatch(openModalPayments(open, typeMembership, typePayment, membershipPeriod))
})
const mapStateToProps = (state) => ({
  modalPayments: state.ModalReducer.openModalPayments
});

export default connect(mapStateToProps, mapDispatchToProps)(MembershipCards);
